import React from 'react';

import { formatDateMMDDYY } from '@mummssoftware/utils/formatters';
import en from '@mummssoftware/utils/translationDefaults/en';
import {
  CareGiverBorder,
  CareGiverTableContainer,
  HalfInterventionContainer,
  HeaderDetail,
  HeaderRow,
  HeaderTitle,
  InterventionsContainer,
  InterventionDetail,
  InterventionTitle,
  NoBereavementText,
  NoBereavementsTextContainer,
  TitleRow,
  InterventionsRow,
} from './styled-divs/styles';

type CareGiverTableProps = {
  careGiversInfo: any;
};

const NoBereavementsComponent = () => (
  <NoBereavementsTextContainer>
    <NoBereavementText>{en.common.noBereavements}</NoBereavementText>
  </NoBereavementsTextContainer>
);

const CareGiverRows = ({ careGiversInfo }: CareGiverTableProps) => {
  const rowUI =
    careGiversInfo &&
    careGiversInfo.length &&
    careGiversInfo.map((info: any) => {
      const interventionScheduleArray =
        info && info.griefriskactions && info.griefriskactions.split('\n');

      const interventionStringArray =
        interventionScheduleArray && interventionScheduleArray.slice();

      const halfInterventionsLength =
        interventionStringArray &&
        Math.ceil(interventionStringArray.length / 2);

      const firstHalfInterventionsArray =
        interventionStringArray &&
        interventionStringArray.slice(0, halfInterventionsLength);

      const secondHalfInterventionsArray =
        interventionStringArray &&
        interventionStringArray.slice(
          halfInterventionsLength,
          interventionStringArray.length - 1,
        );
      return (
        <CareGiverBorder key={`caregiver-${info.id}`}>
          <HeaderRow>
            <HeaderDetail>{`${info.caregiverlastname || ''}`}</HeaderDetail>
            <HeaderDetail>{`${info.caregiverfirstname || ''}`}</HeaderDetail>
            <HeaderDetail>{`${info.caregiverrelationship || ''}`}</HeaderDetail>
            <HeaderDetail>{`${info.griefRisk || ''}`}</HeaderDetail>
            <HeaderDetail>
              {`${formatDateMMDDYY(info.bereavedStartDate)}`}
            </HeaderDetail>
          </HeaderRow>
          {interventionScheduleArray && (
            <InterventionsContainer>
              <InterventionTitle>
                {en.common.interventionSchedule}
              </InterventionTitle>
              <InterventionsRow>
                <HalfInterventionContainer>
                  {firstHalfInterventionsArray &&
                    firstHalfInterventionsArray.length &&
                    firstHalfInterventionsArray.map(
                      (intervention: string, i: number) => (
                        <InterventionDetail
                          // eslint-disable-next-line react/no-array-index-key
                          key={`intervention-${info.id}-${i}`}
                        >
                          {`• ${intervention}`}
                        </InterventionDetail>
                      ),
                    )}
                </HalfInterventionContainer>
                <HalfInterventionContainer>
                  {secondHalfInterventionsArray &&
                    secondHalfInterventionsArray.length &&
                    secondHalfInterventionsArray.map(
                      (intervention: string, i: number) => (
                        <InterventionDetail
                          // eslint-disable-next-line react/no-array-index-key
                          key={`intervention-${info.id}-${i}`}
                        >
                          {`• ${intervention}`}
                        </InterventionDetail>
                      ),
                    )}
                </HalfInterventionContainer>
              </InterventionsRow>
            </InterventionsContainer>
          )}
        </CareGiverBorder>
      );
    });

  return <div>{rowUI}</div>;
};

export const CareGiverTable = ({ careGiversInfo }: CareGiverTableProps) => (
  <CareGiverTableContainer>
    <TitleRow>
      <HeaderTitle>{en.common.cgLastName}</HeaderTitle>
      <HeaderTitle>{en.common.cgFirstName}</HeaderTitle>
      <HeaderTitle>{en.common.relation}</HeaderTitle>
      <HeaderTitle>{en.common.riskLevel}</HeaderTitle>
      <HeaderTitle>{en.common.startDate}</HeaderTitle>
    </TitleRow>
    {(careGiversInfo && <CareGiverRows careGiversInfo={careGiversInfo} />) || (
      <NoBereavementsComponent />
    )}
  </CareGiverTableContainer>
);
